import { toast } from "sonner";

// import * as XLSX from 'xlsx';
import XLSX from 'xlsx-js-style';

const MESES = [
    { value: "1", label: "Enero" },
    { value: "2", label: "Febrero" },
    { value: "3", label: "Marzo" },
    { value: "4", label: "Abril" },
    { value: "5", label: "Mayo" },
    { value: "6", label: "Junio" },
    { value: "7", label: "Julio" },
    { value: "8", label: "Agosto" },
    { value: "9", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
];

const getMesNombre = (mesNum) => {
    return MESES.find(m => m.value === mesNum.toString())?.label || '';
};


const pintarFila = (ws, rowIndex, colorFondo = "0000FF") => {
    ["A", "B", "C", "D"].forEach(col => {
        const cellRef = `${col}${rowIndex + 1}`;
        if (ws[cellRef]) {
            ws[cellRef].s = {
                fill: { fgColor: { rgb: colorFondo } },
                font: { color: { rgb: "FFFFFF" }, bold: true },
            };
        }
    });
};
const pintarFilaRes = (ws, rowIndex, colorFondo = "0000FF") => {
    ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"].forEach(col => {
        const cellRef = `${col}${rowIndex + 1}`;
        if (ws[cellRef]) {
            ws[cellRef].s = {
                fill: { fgColor: { rgb: colorFondo } },
                font: { color: { rgb: "FFFFFF" }, bold: true },
            };
        }
    });
};
export const handleDescargarExcel = (reporte, user) => {
    if (!reporte) {
        toast.error("No hay datos para descargar");
        return;
    }

    try {
        // Crear un nuevo libro de trabajo
        const wb = XLSX.utils.book_new();

        const e31 = reporte.resumen.filter(r => r.tipo === 'E31');
        const e32 = reporte.resumen.filter(r => r.tipo === 'E32');
        const e34 = reporte.resumen.filter(r => r.tipo === 'E34');
        const e44 = reporte.resumen.filter(r => r.tipo === 'E44');
        const e45 = reporte.resumen.filter(r => r.tipo === 'E45');
        const e46 = reporte.resumen.filter(r => r.tipo === 'E46');
        const eventa = reporte.resumen.filter(r => ['E31', 'E32', 'E34', 'E44', 'E45', 'E46'].includes(r.tipo));

        // // Hoja 4: Formato 607
        // const formato607Data = [
        //     [`${user?.nombre_comercial}`],
        //     [`RNC: ${user?.rnc}`],
        //     ["IT1 ANEXO A"],
        //     [`Período: ${getMesNombre(reporte.periodo.mes)} ${reporte.periodo.ano}`],
        //     [],
        //     ["II. OPERACIONES REPORTADAS EN EL 607, LIBRO DE VENTAS Y FACTURA ELECTRÓNICA (E-NCF) POR TIPO DE NCF", "CANTIDAD", "", "MONTO"],

        //     ["COMPROBANTES VÁLIDO PARA CRÉDITO FISCAL (01 y 31)", e31.reduce((acc, f) => acc + parseFloat(parseFloat(f.cantidad).toFixed(2)), 0), "+", e31.reduce((acc, f) => acc + parseFloat((parseFloat(f.monto) - parseFloat(f.impuesto)).toFixed(2)), 0)],
        //     ["COMPROBANTES CONSUMO (02 y 32)                   ", e32.reduce((acc, f) => acc + parseFloat(parseFloat(f.cantidad).toFixed(2)), 0), "+", e32.reduce((acc, f) => acc + parseFloat((parseFloat(f.monto) - parseFloat(f.impuesto)).toFixed(2)), 0)],
        //     ["COMPROBANTES NOTA DE DÉBITO (03 y 33)            ", 0, "+", 0],
        //     ["COMPROBANTES NOTA DE CRÉDITO (04 y 34)           ", e34.reduce((acc, f) => acc + parseFloat(parseFloat(f.cantidad).toFixed(2)), 0), "-", e34.reduce((acc, f) => acc + parseFloat((parseFloat(f.monto) - parseFloat(f.impuesto)).toFixed(2)), 0)],
        //     ["COMPROBANTES REGISTRO ÚNICO DE INGRESOS (12)     ", 0, "+", 0],
        //     ["COMPROBANTES REGÍMENES ESPECIALES (14 y 44)      ", e44.reduce((acc, f) => acc + parseFloat(parseFloat(f.cantidad).toFixed(2)), 0), "+", e44.reduce((acc, f) => acc + parseFloat((parseFloat(f.monto) - parseFloat(f.impuesto)).toFixed(2)), 0)],
        //     ["COMPROBANTES GUBERNAMENTALES (15 y 45)           ", e45.reduce((acc, f) => acc + parseFloat(parseFloat(f.cantidad).toFixed(2)), 0), "+", e45.reduce((acc, f) => acc + parseFloat((parseFloat(f.monto) - parseFloat(f.impuesto)).toFixed(2)), 0)],
        //     ["COMPROBANTES PARA EXPORTACIONES (16 y 46)        ", e46.reduce((acc, f) => acc + parseFloat(parseFloat(f.cantidad).toFixed(2)), 0), "+", e46.reduce((acc, f) => acc + parseFloat((parseFloat(f.monto) - parseFloat(f.impuesto)).toFixed(2)), 0)],
        //     ["OTRAS OPERACIONES (POSITIVAS)", "", "+", ""],
        //     ["OTRAS OPERACIONES (NEGATIVAS)", "", "-", ""],
        //     ["TOTAL OPERACIONES", "", "=", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = (parseFloat(f.monto) - parseFloat(f.impuesto)) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],

        //     [],
        //     ["III. OPERACIONES REPORTADAS EN EL 607 POR TIPO DE VENTA (MONTO TOTAL INCLUYENDO IMPUESTOS)", "", "", "MONTO BRUTO"],

        //     ["EFECTIVO", "", "+", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = parseFloat(f.efectivo) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],
        //     ["CHEQUE / TRANSFERENCIA", "", "+", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = parseFloat(f.cheque_transferencia_deposito) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],
        //     ["TARJETA DÉBITO / CRÉDITO", "", "+", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = parseFloat(f.tarjeta_debito_credito) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],
        //     ["A CRÉDITO", "", "+", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = parseFloat(f.venta_a_credito) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],
        //     ["BONOS O CERTIFICADOS DE REGALO", "", "+", 0],
        //     ["PERMUTAS", "", "+", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = parseFloat(f.permuta) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],
        //     ["OTRAS FORMAS DE VENTA", "", "+", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = parseFloat(f.otras_formas_pago) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],
        //     ["TOTAL OPERACIONES POR TIPO DE VENTA", "", "=", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = parseFloat(f.monto) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],
        //     [],
        //     [],
        //     [],
        //     ["II. INGRESOS POR OPERACIONES", "", "", "MONTO"],

        //     ["TOTAL DE OPERACIONES DEL PERIODO (Proviene de la casilla 11 del Anexo A)", "", "+", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = parseFloat(f.monto) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],

        //     ["II.A NO GRAVADAS", "", "", ""],

        //     ["INGRESOS POR EXPORTACIONES DE BIENES", "", "+", 0],
        //     ["INGRESOS POR EXPORTACIONES DE SERVICIOS", "", "+", 0],
        //     ["INGRESOS POR VENTAS LOCALES EXENTAS", "", "+", 0],
        //     ["INGRESOS POR VENTAS EXENTAS POR DESTINO", "", "+", 0],
        //     ["NO SUJETAS A ITBIS (CONSTRUCCIÓN)", "", "+", 0],
        //     ["NO SUJETAS A ITBIS POR COMISIONES", "", "+", 0],
        //     ["INGRESOS POR VENTAS EXENTAS (LEYES)", "", "+", 0],

        //     ["TOTAL INGRESOS POR OPERACIONES NO GRAVADAS", "", "=", 0],

        //     ["II.B GRAVADAS", "", "", ""],

        //     ["TOTAL INGRESOS POR OPERACIONES GRAVADAS", "", "=", reporte.totales.monto],
        //     ["OPERACIONES GRAVADAS AL 18%", "", "=", reporte.totales.monto],
        //     ["OPERACIONES GRAVADAS AL 16%", "", "=", 0],
        //     ["OPERACIONES GRAVADAS AL 9%", "", "=", 0],
        //     ["OPERACIONES GRAVADAS AL 8%", "", "=", 0],
        //     ["OPERACIONES GRAVADAS ACTIVOS DEPRECIABLES", "", "=", 0],
        //     [],
        //     [],
        //     ["III LIQUIDACION", "", "", ""],
        //     ["ITBIS COBRADO (18% de la casilla 11)", "", "=", parseFloat(eventa.reduce((acc, f) => {
        //         const monto = parseFloat(f.impuesto) || 0;
        //         return acc + (f.tipo === 'E34' ? -monto : monto);
        //     }, 0).toFixed(2))],
        //     ["ITBIS COBRADO (16% de la casilla 12)", "", "=", 0],
        //     ["ITBIS COBRADO (9% de la casilla 13)", "", "=", 0],
        //     ["ITBIS COBRADO (8% de la casilla 14)", "", "=", 0],
        //     ["TOTAL ITBIS COBRADO", "", "=", 0],
        // ];

        // // Crear hoja

        // const ws607 = XLSX.utils.aoa_to_sheet(formato607Data);

        // [
        //     "II. OPERACIONES REPORTADAS EN EL 607, LIBRO DE VENTAS Y FACTURA ELECTRÓNICA (E-NCF) POR TIPO DE NCF",
        //     "III. OPERACIONES REPORTADAS EN EL 607 POR TIPO DE VENTA (MONTO TOTAL INCLUYENDO IMPUESTOS)",
        //     "II. INGRESOS POR OPERACIONES",
        //     "II.A NO GRAVADAS",
        //     "II.B GRAVADAS",
        //     "III LIQUIDACION",

        // ].map((row) => {
        //     const rowIndex = formato607Data.findIndex(r => r[0] === row);
        //     pintarFila(ws607, rowIndex);
        // })


        // // Ajustar columnas
        // ws607['!cols'] = [
        //     { wch: 70 },
        //     { wch: 5 },
        //     { wch: 12 },
        //     { wch: 20 }
        // ];

        // Agregar hoja al libro
        // XLSX.utils.book_append_sheet(wb, ws607, "IT1-Anexo A");

        const totalventa = reporte.resumen
            .filter(r => ['E31', 'E32', 'E44', 'E45'].includes(r.tipo))
            .reduce((acc, item) => {
                acc.cantidad += Number(item.cantidad || 0);
                acc.impuesto += Number(item.impuesto || 0);
                acc.monto += Number(item.monto || 0);
                acc.efectivo += Number(item.efectivo || 0);
                acc.cheque_transferencia_deposito += Number(item.cheque_transferencia_deposito || 0);
                acc.tarjeta_debito_credito += Number(item.tarjeta_debito_credito || 0);
                acc.venta_a_credito += Number(item.venta_a_credito || 0);
                acc.permuta += Number(item.permuta || 0);
                acc.nota_de_credito += Number(item.nota_de_credito || 0);
                acc.otras_formas_pago += Number(item.otras_formas_pago || 0);
                return acc;
            }, {
                cantidad: 0,
                impuesto: 0,
                monto: 0,
                efectivo: 0,
                cheque_transferencia_deposito: 0,
                tarjeta_debito_credito: 0,
                venta_a_credito: 0,
                permuta: 0,
                nota_de_credito: 0,
                otras_formas_pago: 0
            });
        const totalcredito = reporte.resumen
            .filter(r => ['E34'].includes(r.tipo))
            .reduce((acc, item) => {
                acc.cantidad += Number(item.cantidad || 0);
                acc.impuesto += Number(item.impuesto || 0);
                acc.monto += Number(item.monto || 0);
                acc.efectivo += Number(item.efectivo || 0);
                acc.cheque_transferencia_deposito += Number(item.cheque_transferencia_deposito || 0);
                acc.tarjeta_debito_credito += Number(item.tarjeta_debito_credito || 0);
                acc.venta_a_credito += Number(item.venta_a_credito || 0);
                acc.permuta += Number(item.permuta || 0);
                acc.nota_de_credito += Number(item.nota_de_credito || 0);
                acc.otras_formas_pago += Number(item.otras_formas_pago || 0);
                return acc;
            }, {
                cantidad: 0,
                impuesto: 0,
                monto: 0,
                efectivo: 0,
                cheque_transferencia_deposito: 0,
                tarjeta_debito_credito: 0,
                venta_a_credito: 0,
                permuta: 0,
                nota_de_credito: 0,
                otras_formas_pago: 0
            });

        // Hoja 1: Resumen de Facturación
        const resumenData = [
            [`${user?.nombre_comercial}`],
            [`RNC: ${user?.rnc}`],
            ["REPORTE DE FACTURACIÓN"],
            [`Período: ${getMesNombre(reporte.periodo.mes)} ${reporte.periodo.ano}`],
            [],
            ["RESUMEN DE FACTURACIÓN"],
            ["Tipo de Comprobante", "Descripcion", "Cantidad Aprobado", "Importe", "Impuesto (ITBIS)", "Monto", "Efectivo", "Cheque-Transferencia", 'Tarjeta', "Venta_a_Credito", "Permuta", "Nota_de_credito", "OtrasFormas"],
            ...reporte.resumen.filter(r => ['E31', 'E32', 'E44', 'E45'].includes(r.tipo)).map(item => [
                item.tipo,
                item.descripcion,
                item.cantidad,
                parseFloat((parseFloat(item.monto) - parseFloat(item.impuesto)).toFixed(2)),
                item.impuesto,
                item.monto,
                item.efectivo,
                item.cheque_transferencia_deposito,
                item.tarjeta_debito_credito,
                item.venta_a_credito,
                item.permuta,
                item.nota_de_credito,
                item.otras_formas_pago
            ]),
            ["TOTALES", "",
                totalventa.cantidad,
                parseFloat((parseFloat(totalventa.monto) - parseFloat(totalventa.impuesto)).toFixed(2)),
                totalventa.impuesto,
                totalventa.monto,
                totalventa.efectivo,
                totalventa.cheque_transferencia_deposito,
                totalventa.tarjeta_debito_credito,
                totalventa.venta_a_credito,
                totalventa.permuta,
                totalventa.nota_de_credito,
                totalventa.otras_formas_pago
            ],
            [],
            ["NOTAS DE CREDITOS", "", "", "", "", "", "", "", "", "", "", ""],
            ...reporte.resumen.filter(r => ['E34'].includes(r.tipo)).map(item => [
                item.tipo,
                item.descripcion,
                item.cantidad,
                parseFloat((parseFloat(item.monto) - parseFloat(item.impuesto)).toFixed(2)),
                item.impuesto,
                item.monto,
                item.efectivo,
                item.cheque_transferencia_deposito,
                item.tarjeta_debito_credito,
                item.venta_a_credito,
                item.permuta,
                item.nota_de_credito,
                item.otras_formas_pago
            ]),
            [],
            ["TOTAL VENTA NETA ->", "", "",
                parseFloat((parseFloat(totalventa.monto - totalcredito.monto) - parseFloat(totalventa.impuesto - totalcredito.impuesto)).toFixed(2)),
                totalventa.impuesto - totalcredito.impuesto,
                totalventa.monto - totalcredito.monto,
                totalventa.efectivo - totalcredito.efectivo,
                totalventa.cheque_transferencia_deposito - totalcredito.cheque_transferencia_deposito,
                totalventa.tarjeta_debito_credito - totalcredito.tarjeta_debito_credito,
                totalventa.venta_a_credito - totalcredito.venta_a_credito,
                totalventa.permuta - totalcredito.permuta,
                totalventa.nota_de_credito - totalcredito.nota_de_credito,
                totalventa.otras_formas_pago - totalcredito.otras_formas_pago
            ],
            [],
            [],
            ['OTROS COMPROBANTES REPORTADOS', "", "", "", "", "", "", "", "", "", "", ""],
            ...reporte.resumen.filter(r => ['E41', 'E43'].includes(r.tipo)).map(item => [
                item.tipo,
                item.descripcion,
                item.cantidad,
                parseFloat((parseFloat(item.monto) - parseFloat(item.impuesto)).toFixed(2)),
                item.impuesto,
                item.monto,
                item.efectivo,
                item.cheque_transferencia_deposito,
                item.tarjeta_debito_credito,
                item.venta_a_credito,
                item.permuta,
                item.nota_de_credito,
                item.otras_formas_pago
            ]),


        ];
        const wsResumen = XLSX.utils.aoa_to_sheet(resumenData);


        [
            "Tipo de Comprobante",
            "NOTAS DE CREDITOS",
            "OTROS COMPROBANTES REPORTADOS",
            "TOTAL VENTA NETA ->"

        ].map((row) => {
            const rowIndex = resumenData.findIndex(r => r[0] === row);
            pintarFilaRes(wsResumen, rowIndex);
        })


        // Ajustar ancho de columnas
        wsResumen['!cols'] = [
            { wch: 25 },
            { wch: 25 },
            { wch: 20 },
            { wch: 15 },
            { wch: 20 },
            { wch: 15 }
        ];

        XLSX.utils.book_append_sheet(wb, wsResumen, "Resumen");

        reporte.resumen.map(tipo => {
            // Hoja 2: Facturas Aprobadas
            if (reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).length > 0) {
                const aprobadasData = [
                    [`${user?.nombre_comercial}`],
                    [`RNC: ${user?.rnc}`],
                    ["REPORTE DE FACTURACIÓN"],
                    [`Período: ${getMesNombre(reporte.periodo.mes)} ${reporte.periodo.ano}`],
                    [],
                    ["FACTURAS EMITIDAS Y APROBADAS"],
                    [`${tipo.descripcion} (${tipo.tipo})`],
                    [],
                    ["id", "Fecha", "Factura", "NCF", "RNC", "Cliente", "ITBIS", "Monto", "Efectivo", "Cheque-Transferencia", 'Tarjeta', "Venta_a_Credito", "Permuta", "Nota_de_credito", "OtrasFormas"],
                    ...reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).map((f, index) => [
                        index + 1,
                        f.fecha_emision,
                        f.factura,
                        f.ncf,
                        f.rnc,
                        f.nombre,
                        parseFloat(f.itbis),
                        parseFloat(f.monto),
                        parseFloat(f.efectivo),
                        parseFloat(f.cheque_transferencia_deposito),
                        parseFloat(f.tarjeta_debito_credito),
                        parseFloat(f.venta_a_credito),
                        parseFloat(f.permuta),
                        parseFloat(f.nota_de_credito),
                        parseFloat(f.otras_formas_pago)
                    ]),
                    ["", "", "", "", "", "",
                        reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).reduce((acc, f) => acc + parseFloat(f.itbis), 0),
                        reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).reduce((acc, f) => acc + parseFloat(f.monto), 0),

                        reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).reduce((acc, f) => acc + parseFloat(f.efectivo), 0),
                        reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).reduce((acc, f) => acc + parseFloat(f.cheque_transferencia_deposito), 0),
                        reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).reduce((acc, f) => acc + parseFloat(f.tarjeta_debito_credito), 0),
                        reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).reduce((acc, f) => acc + parseFloat(f.venta_a_credito), 0),
                        reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).reduce((acc, f) => acc + parseFloat(f.permuta), 0),
                        reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).reduce((acc, f) => acc + parseFloat(f.nota_de_credito), 0),
                        reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).reduce((acc, f) => acc + parseFloat(f.otras_formas_pago), 0),
                    ],
                    [],
                    [`Total de facturas aprobadas: ${reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).length}`]
                ];
                const wsAprobadas = XLSX.utils.aoa_to_sheet(aprobadasData);

                wsAprobadas['!cols'] = [
                    { wch: 8 },
                    { wch: 12 },
                    { wch: 20 },
                    { wch: 20 },
                    { wch: 20 },
                    { wch: 40 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 15 }
                ];



                XLSX.utils.book_append_sheet(wb, wsAprobadas, `Comprobante ${tipo.tipo} (${reporte.facturas_aprobadas.filter(f => f.tipo === tipo.tipo).length}} `);
            }
        })




        // Hoja 3: Facturas Rechazadas
        if (reporte.facturas_rechazadas.length > 0) {
            const rechazadasData = [
                ["FACTURAS RECHAZADAS"],
                [],
                ["id", "Fecha", "NCF", "RNC", "Cliente", "Monto", "Estado Firma"],
                ...reporte.facturas_rechazadas.map((f, index) => [
                    index + 1,

                    f.fecha_emision,

                    f.ncf,
                    f.rnc,
                    f.nombre,
                    parseFloat(f.monto),
                    f.estado_firma
                ]),
                [],
                [`Total de facturas rechazadas: ${reporte.facturas_rechazadas.length} `]
            ];
            const wsRechazadas = XLSX.utils.aoa_to_sheet(rechazadasData);

            wsRechazadas['!cols'] = [
                { wch: 12 },
                { wch: 12 },
                { wch: 18 },
                { wch: 12 },
                { wch: 50 },
                { wch: 15 },
                { wch: 15 }
            ];

            XLSX.utils.book_append_sheet(wb, wsRechazadas, "Facturas Rechazadas");
        }

        // Generar archivo
        const nombreArchivo = `Reporte_Facturacion_${getMesNombre(reporte.periodo.mes)}_${reporte.periodo.ano}.xlsx`;
        XLSX.writeFile(wb, nombreArchivo);

        toast.success("Archivo Excel descargado exitosamente");
    } catch (error) {
        console.error("Error al generar Excel:", error);
        toast.error("Error al generar el archivo Excel");
    }
};